export const EMPTY_STRING = ""
export const UNKNOW_STRING = "unknown"

export function isEmptyString(str) {
    return str === ""
}